import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import useDebounce from '../../hooks/useDebounce';
import Iconify from '../Iconify';
import '../../css/invoices/invoiceFiltration.css';

const InvoicesFiltration = ({ filtersEmpty, invoiceFilters, setInvoicefilters, totalInvoices, filteredInvoicesCount, invoicesFetched }) => {

    const [search, setSearch] = useState(invoiceFilters.debouncedSearch || '');
    const [amount, setAmount] = useState(invoiceFilters.debouncedAmount || '');
    const debouncedSearch = useDebounce(search, 1000);
    const debouncedAmount = useDebounce(amount, 1000);

    // Update filters when debounced search changes
    useEffect(() => {
        setInvoicefilters((prev) => ({ ...prev, debouncedSearch: debouncedSearch }));
    }, [debouncedSearch, setInvoicefilters]);

    useEffect(() => {
        setInvoicefilters((prev) => ({ ...prev, debouncedAmount: debouncedAmount }));
    }, [debouncedAmount, setInvoicefilters]);

    const clearFilters = useCallback(() => {
        setInvoicefilters({
            ...invoiceFilters,
            debouncedSearch: '',
            debouncedAmount: null,
            company: '',
            date: null
        });
        setAmount(null);
        setSearch('');
    }, [setInvoicefilters, invoiceFilters, setAmount, setSearch]);


    return (
        <Box className='invoiceFiltration_main_box'>
            <Box className='invoiceFiltration_counts'>
                <Box className='invoiceFiltration_search_clear_box'>
                        <TextField
                            size="small"
                            value={search}
                            placeholder='Rechercher'
                            onChange={(e) => setSearch(e.target.value)}
                            variant="outlined"
                            className='invoiceFiltration_search_Box'
                            InputProps={{
                                startAdornment: <Iconify icon={"bx:bx-search"} className='invoiceFiltration_search_icon' />,
                                sx: {
                                    backgroundColor: '#fff',
                                    height: '36px',
                                    fontFamily: 'Mulish',
                                    color: '#201E1E',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                },
                            }}
                        />
                    <Typography className='invoiceFiltration_clearAll' onClick={clearFilters}>Re-initialiser</Typography>
                </Box>
                <Typography className='invoiceFiltration_total_number'>
                    {invoicesFetched} affichés
                    {(!filtersEmpty && JSON.stringify(invoiceFilters.debouncedAmount) !== JSON.stringify([100, 100])) && ` / ${filteredInvoicesCount} filtrés`}
                    {` / ${totalInvoices} au total`}
                </Typography>
            </Box>
        </Box>
    );
};

export default InvoicesFiltration;